import ReactSelect from "react-select";
import { useTranslation } from "react-i18next";
import Input from "../../Atoms/Input";
import React from "react";
import { FD100MultiSelectOptions} from "../../Utils/Listings"

function valuesToOptions(value, options) {
    //make sure value is an array
    if (!Array.isArray(value)) {
        value = [value];
    }
    const optionsFlattened = []
    for (let i = 0; i < options.length; i++) {
        if (options[i].options) {
            optionsFlattened.push(...options[i].options);
        }
        if (options[i].value) {
            optionsFlattened.push(options[i]);
        }
    }
    return optionsFlattened.filter(opt => value.includes(opt.value));
}

const Step1 = (props) => {

    const defaultValues = props.defaultValues || {};

    const { i18n } = useTranslation('common');

    const partageCultureFrancaiseFD100 = FD100MultiSelectOptions.partageCultureFrancaiseFD100(i18n.language);

    return (<>
        <div className="dropdown-container">
            <h2 className="formtitle" style={{ marginBottom: '20px'}}>{i18n.language === "fr" ? "Le Candidat doit partager la culture française en étant : *" : "The Candidate must share the French culture by being: *"}</h2>
            <ReactSelect
                name="culture_francaise"
                options={partageCultureFrancaiseFD100}
                placeholder={i18n.language === "fr" ? "Sélectionnez votre réponses" : "Choose your answer"}
                style={{ marginBottom: '20px', marginTop: '20px' }}
                required
                defaultValue={valuesToOptions(defaultValues.culture_francaise, partageCultureFrancaiseFD100)}
            />
            <br></br>
            <h2 className="formtitle" style={{ marginBottom: '20px', marginTop: '40px' }}>{i18n.language === "fr" ? "Coordonnées de la personne à contacter dans le cadre de cette candidature*" : "Contact details of the person to be contacted in the context of this application*"}</h2>
            {/* les noms enregistrés sont définitifs et qu'en cas de changement, elle devra être notifié par email. */}
            {/* <h2 className="formtitle" style={{ marginBottom: '20px', color: "red" }}>{i18n.language === "fr" ? "Les informations de contact enregistrées sont définitives et en cas de changement, vous devrez nous en informer par email." : "The contact information saved is final and in case of change, you will have to inform us by email."}</h2> */}
            <div className="flexblock">
                <Input required style={{ width: "100%", zIndex: "0" }} name="contact_nom" placeholder={i18n.language === "fr" ? "Nom" : "Last name"} defaultValue={defaultValues?.contact_nom} />
                <Input required style={{ width: "100%", zIndex: "0" }} name="contact_prenom" placeholder={i18n.language === "fr" ? "Prénom" : "First name"} defaultValue={defaultValues?.contact_prenom} />
            </div>
            <div className="flexblock">
                <Input required style={{ width: "100%", zIndex: "0" }} name="contact_mail" placeholder={i18n.language === "fr" ? "Mail" : "Email"} defaultValue={defaultValues?.contact_mail} />
                <Input required style={{ width: "100%", zIndex: "0" }} name="contact_telephone" placeholder={i18n.language === "fr" ? "Téléphone portable" : "Mobile phone"} defaultValue={defaultValues?.contact_telephone} />
            </div>
        </div>
    </>);
}

export default Step1;